import { selector } from 'recoil';

import { supabase } from '../utils/supabaseClient';
import { factoryPicker } from './factoryPicker';
import { partnerPicker } from './partnerPicker';

export const stationsQuery = selector({
  key: 'Stations',
  get: async ({ get }) => {
    const partner = get(partnerPicker);
    if (!partner) {
      return null;
    }

    const query = supabase
      .from('zones')
      .select('zone_sequence, stations(*)')
      .eq('partner_name', partner.partner_name)
      .is('is_archived', false)
      .is('stations.is_archived', false)
      .order('factory_name')
      .order('zone_sequence');
    const factory = get(factoryPicker);
    if (factory) {
      query.eq('factory_name', factory);
    }
    const response = await query;
    return response.data?.flatMap((zone) =>
      [...zone.stations].sort((a, b) => a.station_sequence - b.station_sequence),
    );
  },
});
